const createMarkup = (html: string) => {
  return { __html: html }
}

export default createMarkup
